/* eslint-disable no-useless-catch */
import { callApi } from '../common/api';
import { API_END_POINTS } from '../config/api-endpoints';
import { events } from './events';

const trackEventFM = async (data:any) => {
  // console.log(data);
  try{
    await callApi({
      method: 'POST',
      url: API_END_POINTS.ANALYTICS.FUNNEL_METRICS,
      data,
    })
    .then((res)=>{
      // console.log(res)
    });
  } catch (e) {
    // console.log(JSON.stringify(e));
    throw e;
  }
};

export function track(eventID:any,payload:any='') {
  const obj = {
      ...events[eventID],
      properties:{ ...payload }
    };
  trackEventFM(obj);
}